<div class="form-group">

  @if (showLabel && (question?.email_version || labelText)) {
    <label
      class="form-group__label"
      [innerHtml]="question?.email_version ? question?.email_version : labelText">
    </label>
  }


  @if (showSkip) {
    <div class="question-skip">
      <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="add-note-toggle"
          [attr.data-id]="question?.data_test_id"
          id="skip-driver-details-toggle">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">Skip for now</span>
        </label>
      </div>
    }

    @if (!showToolTip) {
      @if (editModal) {
        <input
          [name]="uniqueControlName"
          (keyup)="upperCase()"
          [id]="uniqueId"
          [placeholder]="question?.question_prompt ? question?.question_prompt : placeHolderText"
          [type]="inputType"
          [(ngModel)]="value"
          (blur)="saveValue()"
          [disabled]="readOnly"
          class="form-control"
          [attr.data-id]="question?.data_test_id"
          >
      }
      @if (!editModal) {
        <input
          [name]="uniqueControlName"
          (keyup)="upperCase()"
          [id]="uniqueId"
          [placeholder]="question?.question_prompt ? question?.question_prompt : placeHolderText"
          [type]="inputType"
          [(ngModel)]="value"
          (ngModelChange)="saveValue()"
          [disabled]="readOnly"
          class="form-control"
          [attr.data-id]="question?.data_test_id"
          >
      }
      <!-- <a href="#" id="clear-address-1" class="form-control__clear"><svg class="icon">
      <use xlink:href="#close-circle-small"></use>
    </svg>
  </a> -->
  <!-- <div *ngIf="question?.cent_aq_question_id === 57 && !editModal">
  <br>
    <a href="javascript:void(0);" (click)="noregNumber()">I do not have a registration number yet (for new vehicles)</a>
  </div> -->
}

@if (showToolTip) {
  <div class="input-wrap">
    @if (editModal) {
      <input
        [name]="uniqueControlName"
        [id]="uniqueId"
        [placeholder]="question?.question_prompt ? question?.question_prompt : placeHolderText"
        [type]="inputType"
        [disabled]="readOnly"
        [(ngModel)]="value"
        (blur)="saveValue()"
        class="form-control"
        [attr.data-id]="question?.data_test_id"
        >
    }
    @if (!editModal) {
      <input
        [name]="uniqueControlName"
        [id]="uniqueId"
        [placeholder]="question?.question_prompt ? question?.question_prompt : placeHolderText"
        [type]="inputType"
        [disabled]="readOnly"
        [(ngModel)]="value"
        (ngModelChange)="saveValue()"
        class="form-control"
        [attr.data-id]="question?.data_test_id"
        >
    }
    @if (toolTipContent !== '' && toolTipContent !== null) {
      <div class="input-wrap-append" >
        <a
          class="input-wrap-button popover-trigger popover-trigger--sm"
          tabindex="0"
          data-toggle="popover"
          data-trigger="focus"
          [attr.data-html]="isToolTipContentHtml"
          [attr.data-placement]="toolTipPlacement"
          [attr.data-content]=toolTipContent>
          <svg class="icon">
            <use xlink:href="#info"></use>
          </svg>
        </a>
      </div>
    }
  </div>
}

@if (isIdInput && !idValid) {
  <p class="form-control-error">
    <svg class="icon">
      <use xlink:href="#warning-filled"></use>
    </svg>
    Invalid ID Number.
  </p>
}

</div>

